import React, { useState, useEffect } from 'react';
import getBackendUrl from './utils/backendConfig';

// ANCIEN COMPOSANT SUPPRIMÉ - Maintenant on utilise ApiControlPanel centralisé
const ApiStatusButton_OLD_REMOVED = () => {
  const [apiStatus, setApiStatus] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  // Configuration du backend
  const getBackendUrl = () => {
    if (process.env.REACT_APP_BACKEND_URL) {
      return process.env.REACT_APP_BACKEND_URL;
    }
    const hostname = window.location.hostname;
    if (hostname === "localhost" || hostname === "127.0.0.1") return "http://localhost:8001";
    return '';
  };

  const BACKEND_URL = getBackendUrl();

  const fetchApiStatus = async () => {
    try {
      const response = await fetch(`${BACKEND_URL}/api/health`);
      if (response.ok) {
        const healthData = await response.json();
        
        const adaptedStatus = {
          timestamp: new Date().toISOString(),
          apis: {
            gemini_1: { color: 'green', name: 'Gemini Key 1', status: 'active' },
            gemini_2: { color: 'green', name: 'Gemini Key 2', status: 'active' },
            gemini_3: { color: 'green', name: 'Gemini Key 3', status: 'active' },
            gemini_4: { color: 'green', name: 'Gemini Key 4', status: 'active' },
            bible_api: { color: healthData.bible_api_configured ? 'green' : 'red', name: 'Bible API', status: healthData.bible_api_configured ? 'active' : 'inactive' }
          },
          active_api: healthData.current_key || 'gemini_1'
        };
        
        setApiStatus(adaptedStatus);
      }
    } catch (error) {
      console.error('[API STATUS] Erreur:', error);
    }
  };

  const getLedColor = (api) => {
    return api.color === 'green' ? '#00ff00' : '#ff0000';
  };

  useEffect(() => {
    fetchApiStatus();
    const interval = setInterval(fetchApiStatus, 10000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <style>
        {`
          @keyframes pulse-green {
            0%, 100% { 
              box-shadow: 0 0 8px #00ff00, 0 0 16px #00ff00; 
              opacity: 1; 
            }
            50% { 
              box-shadow: 0 0 12px #00ff00, 0 0 24px #00ff00; 
              opacity: 0.8; 
            }
          }
          @keyframes pulse-red {
            0%, 100% { 
              box-shadow: 0 0 8px #ff0000, 0 0 16px #ff0000; 
              opacity: 1; 
            }
            50% { 
              box-shadow: 0 0 12px #ff0000, 0 0 24px #ff0000; 
              opacity: 0.4; 
            }
          }
          .api-tooltip-character {
            position: absolute;
            top: -40px;
            left: 50%;
            transform: translateX(-50%);
            background: rgba(0,0,0,0.9);
            color: white;
            padding: 6px 12px;
            borderRadius: 8px;
            fontSize: 10px;
            whiteSpace: nowrap;
            zIndex: 1001;
            opacity: 0;
            transition: opacity 0.3s ease;
          }
          .api-tooltip-character.visible {
            opacity: 1;
          }
        `}
      </style>

      <button
        onClick={() => setIsOpen(!isOpen)}
        style={{
          background: 'linear-gradient(135deg, #3742fa, #2f3542)',
          border: 'none',
          borderRadius: '10px',
          color: 'white',
          padding: '8px 14px',
          fontSize: '12px',
          fontWeight: '600',
          cursor: 'pointer',
          transition: 'all 0.3s ease',
          boxShadow: '0 3px 10px rgba(55, 66, 250, 0.3)',
          fontFamily: 'Montserrat, sans-serif',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          position: 'relative',
          overflow: 'hidden'
        }}
        onMouseOver={(e) => {
          e.target.style.transform = 'translateY(-1px)';
          e.target.style.boxShadow = '0 4px 15px rgba(55, 66, 250, 0.4)';
          setShowTooltip(true);
        }}
        onMouseOut={(e) => {
          e.target.style.transform = 'translateY(0px)';
          e.target.style.boxShadow = '0 3px 10px rgba(55, 66, 250, 0.3)';
          setShowTooltip(false);
        }}
      >
        <span>⚡ API</span>
        
        {apiStatus && (
          <div style={{ 
            display: 'flex', 
            alignItems: 'center',
            gap: '4px',
            background: 'rgba(255,255,255,0.15)',
            padding: '2px 6px',
            borderRadius: '6px'
          }}>
            <div style={{
              width: '6px',
              height: '6px',
              borderRadius: '50%',
              backgroundColor: Object.values(apiStatus.apis).every(api => api.color === 'green') ? '#00ff00' : '#ff0000',
              animation: Object.values(apiStatus.apis).every(api => api.color === 'green') ? 'pulse-green 2s infinite' : 'pulse-red 1s infinite'
            }} />
            
            <div style={{ display: 'flex', gap: '2px' }}>
              {Object.entries(apiStatus.apis).map(([key, api]) => (
                <div 
                  key={key}
                  style={{
                    width: '4px',
                    height: '4px',
                    borderRadius: '50%',
                    backgroundColor: getLedColor(api),
                    animation: api.color === 'green' ? 'pulse-green 2s infinite' : 'pulse-red 1s infinite'
                  }}
                  title={`${api.name}: ${api.status}`}
                />
              ))}
            </div>
          </div>
        )}

        {showTooltip && apiStatus && (
          <div className={`api-tooltip-character ${showTooltip ? 'visible' : ''}`}>
            {Object.values(apiStatus.apis).every(api => api.color === 'green') 
              ? '🟢 Toutes les API sont opérationnelles' 
              : '🔴 Certaines API ont des problèmes'
            }
          </div>
        )}
      </button>

      {isOpen && (
        <div style={{
          position: 'absolute',
          top: '100%',
          right: '0',
          marginTop: '10px',
          background: 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(10px)',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          borderRadius: '12px',
          padding: '16px',
          minWidth: '280px',
          boxShadow: '0 10px 30px rgba(0,0,0,0.2)',
          zIndex: 1000
        }}>
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '12px',
            borderBottom: '1px solid rgba(0,0,0,0.1)',
            paddingBottom: '8px'
          }}>
            <h4 style={{
              margin: 0,
              color: '#333',
              fontSize: '14px',
              fontWeight: 'bold'
            }}>
              🔧 Statut des API
            </h4>
            <button
              onClick={() => setIsOpen(false)}
              style={{
                background: 'none',
                border: 'none',
                fontSize: '16px',
                cursor: 'pointer',
                color: '#666'
              }}
            >
              ×
            </button>
          </div>

          {apiStatus && (
            <div style={{ fontSize: '12px' }}>
              {Object.entries(apiStatus.apis).map(([key, api]) => (
                <div 
                  key={key}
                  style={{ 
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '6px 0',
                    borderBottom: '1px solid rgba(0,0,0,0.05)'
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div style={{
                      width: '8px',
                      height: '8px',
                      borderRadius: '50%',
                      backgroundColor: getLedColor(api),
                      animation: api.color === 'green' ? 'pulse-green 2s infinite' : 'pulse-red 1s infinite'
                    }} />
                    <span style={{ color: '#333', fontWeight: '500' }}>
                      {api.name}
                    </span>
                  </div>
                  <span style={{ 
                    color: api.color === 'green' ? '#059669' : '#dc2626',
                    fontSize: '11px',
                    fontWeight: '600'
                  }}>
                    {api.color === 'green' ? '✅ OK' : '❌ ERR'}
                  </span>
                </div>
              ))}
            </div>
          )}

          <button
            onClick={fetchApiStatus}
            style={{
              marginTop: '12px',
              width: '100%',
              padding: '8px',
              background: 'linear-gradient(135deg, #3742fa, #2f3542)',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: '12px',
              fontWeight: '600',
              cursor: 'pointer'
            }}
          >
            🔄 Rafraîchir
          </button>
        </div>
      )}
    </div>
  );
};

const CharacterHistoryPage = ({ character, onGoBack }) => {
  const [history, setHistory] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [apiUsed, setApiUsed] = useState("");
  const [wordCount, setWordCount] = useState(0);
  const [generationMode, setGenerationMode] = useState("standard"); // 'standard', 'enrich', 'regenerate'

  useEffect(() => {
    if (character) {
      generateCharacterHistory('standard');
    }
  }, [character]);

  const generateCharacterHistory = async (mode = 'standard') => {
    setIsLoading(true);
    setGenerationMode(mode);
    
    try {
      const requestBody = {
        character_name: character,
        mode: mode
      };
      
      // Si mode enrichissement, envoyer le contenu actuel
      if (mode === 'enrich' && history) {
        requestBody.previous_content = history;
      }
      
      const backendUrl = getBackendUrl();
      console.log('[CHARACTER HISTORY] Backend URL:', backendUrl);
      console.log('[CHARACTER HISTORY] Génération pour:', character, 'Mode:', mode);
      
      // Appel API pour générer l'histoire narrative du personnage
      const response = await fetch(`${backendUrl}/api/generate-character-history`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody)
      });

      if (!response.ok) {
        throw new Error(`Erreur API: ${response.status}`);
      }

      const result = await response.json();
      
      if (result.status === 'success') {
        setHistory(result.content);
        setApiUsed(result.api_used);
        setWordCount(result.word_count || 0);
        console.log(`[CHARACTER HISTORY] Génération ${mode} réussie pour ${character} - ${result.word_count} mots - API: ${result.api_used}`);
      } else {
        throw new Error(result.message || 'Erreur lors de la génération du contenu');
      }

    } catch (error) {
      console.error("Erreur génération histoire:", error);
      
      // Contenu de secours si l'API échoue
      const fallbackContent = `# 📖 ${character.toUpperCase()} - Histoire Biblique

## ⚠️ GÉNÉRATION TEMPORAIREMENT INDISPONIBLE

Une erreur temporaire empêche la génération de l'histoire complète de **${character}**.

### 🔄 Solutions possibles :

1. **Réessayez dans quelques minutes** - Les serveurs se libèrent régulièrement
2. **Vérifiez votre connexion internet**
3. **Contactez le support** si le problème persiste

### 📚 En attendant, vous pouvez :

- Utiliser la **Concordance Biblique** pour rechercher des versets concernant ${character}
- Consulter les **30 Thèmes Essentiels** pour explorer des sujets connexes
- Naviguer vers d'autres personnages bibliques

*Service de génération automatique - Erreur temporaire*`;
      
      setHistory(fallbackContent);
      setApiUsed("fallback");

    } finally {
      setIsLoading(false);
    }
  };

  // Fonction helper pour convertir les références bibliques en URLs YouVersion
  const getBibleVerseUrl = (book, chapter, verse) => {
    // Mapping des livres français vers codes YouVersion
    const bookMapping = {
      'Genèse': 'GEN', 'Exode': 'EXO', 'Lévitique': 'LEV', 'Nombres': 'NUM', 'Deutéronome': 'DEU',
      'Josué': 'JOS', 'Juges': 'JDG', 'Ruth': 'RUT', '1 Samuel': '1SA', '2 Samuel': '2SA',
      '1 Rois': '1KI', '2 Rois': '2KI', '1 Chroniques': '1CH', '2 Chroniques': '2CH',
      'Esdras': 'EZR', 'Néhémie': 'NEH', 'Esther': 'EST', 'Job': 'JOB', 'Psaumes': 'PSA',
      'Proverbes': 'PRO', 'Ecclésiaste': 'ECC', 'Cantique': 'SNG', 'Ésaïe': 'ISA',
      'Jérémie': 'JER', 'Lamentations': 'LAM', 'Ézéchiel': 'EZK', 'Daniel': 'DAN',
      'Osée': 'HOS', 'Joël': 'JOL', 'Amos': 'AMO', 'Abdias': 'OBA', 'Jonas': 'JON',
      'Michée': 'MIC', 'Nahum': 'NAM', 'Habacuc': 'HAB', 'Sophonie': 'ZEP', 'Aggée': 'HAG',
      'Zacharie': 'ZEC', 'Malachie': 'MAL', 'Matthieu': 'MAT', 'Marc': 'MRK', 'Luc': 'LUK',
      'Jean': 'JHN', 'Actes': 'ACT', 'Romains': 'ROM', '1 Corinthiens': '1CO', '2 Corinthiens': '2CO',
      'Galates': 'GAL', 'Éphésiens': 'EPH', 'Philippiens': 'PHP', 'Colossiens': 'COL',
      '1 Thessaloniciens': '1TH', '2 Thessaloniciens': '2TH', '1 Timothée': '1TI', '2 Timothée': '2TI',
      'Tite': 'TIT', 'Philémon': 'PHM', 'Hébreux': 'HEB', 'Jacques': 'JAS', '1 Pierre': '1PE',
      '2 Pierre': '2PE', '1 Jean': '1JN', '2 Jean': '2JN', '3 Jean': '3JN', 'Jude': 'JUD',
      'Apocalypse': 'REV'
    };
    
    const bookCode = bookMapping[book] || 'GEN';
    // Version LSG (Louis Segond) en français = ID 93 sur YouVersion
    return `https://www.bible.com/bible/93/${bookCode}.${chapter}.${verse}.LSG`;
  };

  const formatHistoryContent = (content) => {
    if (!content) return "";

    const H2 = 'color: #1e293b; margin: 28px 0 14px 0; font-size: 20px; font-weight: 700; font-family: Montserrat, sans-serif; border-bottom: 2px solid #8b5cf6; padding-bottom: 8px; line-height: 1.3;';
    const H1 = "font-family: 'Playfair Display', Georgia, serif; font-size: 24px; font-weight: 800; color: #1e293b; margin: 0 0 28px 0; letter-spacing: -0.02em; line-height: 1.2; text-align: center; padding-bottom: 16px; border-bottom: 2px solid #8b5cf6;";

    // Pré-traitement ligne par ligne : supprime --- et convertit les titres/sections
    const prepped = content
      .replace(/\r\n/g, '\n').replace(/\r/g, '\n')
      .split('\n')
      .map(line => {
        const t = line.trim();
        if (!t || /^-{3,}$/.test(t)) return '';
        if (/^# /.test(t)) return `<h1 style="${H1}">${t.slice(2).trim()}</h1>`;
        if (/^## /.test(t) && !/RÉCIT DE VIE/i.test(t)) return `<h2 style="${H2}">${t.slice(3).trim()}</h2>`;
        // Ligne commençant par un ou plusieurs emojis + texte en MAJUSCULES
        const em = t.match(/^([^\w\d]{1,12})([A-ZÀÂÄÉÈÊËÎÏÔÙÛÜŸÇÆŒ][A-ZÀÂÄÉÈÊËÎÏÔÙÛÜŸÇÆŒ\s\-\/\(\)0-9]{2,})$/);
        if (em) return `<h2 style="${H2}">${t}</h2>`;
        return line;
      })
      .join('\n');

    return prepped
      // Supprimer les # résiduels seuls
      .replace(/^\s*#\s*$/gm, '')
      .replace(/\n\s*#\s*\n/g, '\n')
      .replace(/<\/p>\s*#\s*<p>/g, '</p><p>')

      // Transformer "## 📖 RÉCIT DE VIE" en "recit de vie :" avec beau CSS
      .replace(/##\s*📖?\s*RÉCIT DE VIE.*$/gim, '<p style="text-align: center; font-weight: 800; font-size: 28px; color: #1e3a8a; margin: 40px 0 30px 0; font-family: Montserrat, sans-serif; letter-spacing: 1px; text-transform: lowercase; background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%); padding: 20px; border-radius: 12px; box-shadow: 0 4px 15px rgba(30, 58, 138, 0.2); border-left: 5px solid #3b82f6; border-right: 5px solid #3b82f6;">recit de vie :</p>')
      
      // Centrer "recit de vie :" si déjà en minuscules
      .replace(/^recit de vie\s*:\s*$/gim, '<p style="text-align: center; font-weight: 800; font-size: 28px; color: #1e3a8a; margin: 40px 0 30px 0; font-family: Montserrat, sans-serif; letter-spacing: 1px; text-transform: lowercase; background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%); padding: 20px; border-radius: 12px; box-shadow: 0 4px 15px rgba(30, 58, 138, 0.2); border-left: 5px solid #3b82f6; border-right: 5px solid #3b82f6;">recit de vie :</p>')
      
      // Titre principal
      .replace(/##\s(.+)/g, '<h2 style="color: #1e293b; margin: 24px 0 20px 0; font-size: 24px; font-weight: 700; font-family: Montserrat, sans-serif; border-bottom: 3px solid #8b5cf6; padding-bottom: 12px; line-height: 1.3;">$1</h2>')
      
      // Sous-titres avec émojis
      .replace(/###\s?🔹\s*(.+)/g, '<h3 style="color: #7c3aed; margin: 20px 0 15px 0; font-size: 18px; font-weight: 600; font-family: Montserrat, sans-serif; display: flex; align-items: center; gap: 8px;"><span style="color: #f59e0b;">🔹</span>$1</h3>')
      
      // Gras pour les passages importants
      .replace(/\*\*(.+?)\*\*/g, '<strong style="color: #7c3aed; font-weight: 700; font-family: Montserrat, sans-serif; background: rgba(139, 92, 246, 0.1); padding: 2px 6px; border-radius: 4px;">$1</strong>')
      
      // Italique pour les mots étrangers et citations
      .replace(/\*(.+?)\*/g, '<em style="color: #64748b; font-style: italic; font-family: Montserrat, sans-serif;">$1</em>')
      
      // Versets cliquables avec style amélioré - Liens directs vers YouVersion en français
      .replace(/(Genèse|Exode|Lévitique|Nombres|Deutéronome|Josué|Juges|Ruth|1 Samuel|2 Samuel|1 Rois|2 Rois|1 Chroniques|2 Chroniques|Esdras|Néhémie|Esther|Job|Psaumes|Proverbes|Ecclésiaste|Cantique|Ésaïe|Jérémie|Lamentations|Ézéchiel|Daniel|Osée|Joël|Amos|Abdias|Jonas|Michée|Nahum|Habacuc|Sophonie|Aggée|Zacharie|Malachie|Matthieu|Marc|Luc|Jean|Actes|Romains|1 Corinthiens|2 Corinthiens|Galates|Éphésiens|Philippiens|Colossiens|1 Thessaloniciens|2 Thessaloniciens|1 Timothée|2 Timothée|Tite|Philémon|Hébreux|Jacques|1 Pierre|2 Pierre|1 Jean|2 Jean|3 Jean|Jude|Apocalypse)\s+(\d+):(\d+(?:-\d+)?)/g, 
        (match, book, chapter, verse) => {
          const url = getBibleVerseUrl(book, chapter, verse);
          return `<span onclick="window.open('${url}', '_blank')" style="background: linear-gradient(135deg, #8b5cf6, #7c3aed); color: white; padding: 6px 12px; border-radius: 8px; cursor: pointer; text-decoration: none; font-weight: 600; font-family: Montserrat, sans-serif; display: inline-block; margin: 3px; transition: all 0.3s ease; box-shadow: 0 2px 8px rgba(139, 92, 246, 0.3);" onmouseover="this.style.transform='translateY(-2px)'; this.style.boxShadow='0 4px 15px rgba(139, 92, 246, 0.4)';" onmouseout="this.style.transform='translateY(0px)'; this.style.boxShadow='0 2px 8px rgba(139, 92, 246, 0.3)';" title="Cliquer pour lire sur YouVersion Bible en français">📖 ${book} ${chapter}:${verse}</span>`;
        })
      
      // Paragraphes narratifs
      .replace(/\n\n/g, '</p><p style="color: #374151; font-size: 16px; line-height: 1.8; font-family: Montserrat, sans-serif; margin: 16px 0; text-align: justify; text-indent: 24px;">')
      
      // Listes avec puces stylées
      .replace(/^- (.+)/gm, '<li style="color: #374151; font-size: 16px; line-height: 1.6; font-family: Montserrat, sans-serif; margin: 8px 0; list-style: none; position: relative; padding-left: 24px;"><span style="position: absolute; left: 0; color: #8b5cf6; font-weight: bold;">•</span>$1</li>')
      
      // Wrap dans des paragraphes si pas déjà fait
      .replace(/^(?!<[hlu]|<\/[hlu])(.+?)(?=\n|$)/gm, '<p style="color: #374151; font-size: 16px; line-height: 1.8; font-family: Montserrat, sans-serif; margin: 16px 0; text-align: justify; text-indent: 24px;">$1</p>');
  };

  return (
    <div className="sub-page">
      {/* Header */}
      <div className="sub-header">
        <button className="sub-back" onClick={onGoBack}>← Retour</button>
        <div className="sub-header-center">
          <div className="sub-title">{character}</div>
          <div className="sub-sub">
            {wordCount > 0 ? `${wordCount} mots${apiUsed ? ` · ${apiUsed}` : ''}` : 'Histoire biblique'}
          </div>
        </div>
        <div className="sub-actions">
          <button
            className="sub-btn accent"
            onClick={() => generateCharacterHistory('enrich')}
            disabled={isLoading || !history}
            title="Enrichir le contenu"
          >
            {isLoading && generationMode === 'enrich' ? '...' : 'Enrichir'}
          </button>
          <button
            className="sub-btn"
            onClick={() => generateCharacterHistory('regenerate')}
            disabled={isLoading}
            title="Régénérer"
          >
            {isLoading && generationMode === 'regenerate' ? '...' : 'Régénérer'}
          </button>
          <div className="sub-sep" />
          <button className="sub-btn" onClick={() => {
            if (onGoBack) {
              onGoBack();
              setTimeout(() => window.dispatchEvent(new CustomEvent('navigate-to-notes')), 100);
            }
          }}>Notes</button>
          <button className="sub-btn" onClick={() => window.open('https://www.bible.com/', '_blank')}>Bible</button>
        </div>
      </div>

      {/* Body */}
      <div className="sub-body">
        <div className="sub-content">
          {isLoading ? (
            <div className="sub-empty">
              <div className="empty-icon">📖</div>
              <h3>Génération de l'Histoire Biblique...</h3>
              <p>Création de l'histoire narrative détaillée de <strong>{character}</strong></p>
            </div>
          ) : (
            <div className="sub-card">
              {apiUsed && apiUsed !== "fallback" && (
                <div style={{ marginBottom: '16px' }}>
                  <span className="sub-tag accent">{apiUsed.toUpperCase()}</span>
                </div>
              )}
              <div
                className="content-text"
                dangerouslySetInnerHTML={{ __html: formatHistoryContent(history) }}
              />
              <div style={{
                marginTop: '24px',
                paddingTop: '16px',
                borderTop: '1px solid var(--border)',
                fontSize: '11px',
                color: 'var(--text-dim)',
                textAlign: 'center'
              }}>
                Basée sur les Saintes Écritures
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CharacterHistoryPage;